const ProfileType = {
  PLC: "plc",
  PLB: "plb",
  PT: "pt",
  BOS: "bos"
};

export default ProfileType;
